import React from 'react';
import {Text, TouchableOpacity, View, StyleSheet} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import I18n from 'i18n-js';
import {useDispatch, useSelector} from 'react-redux';
import {setShowCartReadyBanner} from '../../actions/scanToCartActions';
import {fontFamily} from '../../helpers/fontFamily';

const CartReadyBanner = () => {
  const dispatch = useDispatch();
  const showBanner = useSelector(state => state.scanToCart.showCartReadyBanner);
  const cartId = useSelector(state => state.scanToCart.activeCart?.cart_id);
  const cartName = useSelector(state => state.scanToCart.activeCart?.cart_name);

  if (!showBanner || !cartId) {
    return null;
  }

  const displayName = (cartName && String(cartName).trim()) || cartId;

  const handleClose = () => {
    dispatch(setShowCartReadyBanner(false));
  };

  return (
    <View style={styles.container} testID="cartReadyBanner">
      <LinearGradient
        locations={[0, 0.13, 1]}
        colors={['#000000', '#fdf359', '#d2c609']}
        style={styles.gradient}>
        <Text style={styles.message}>
          {I18n.t('cartAssignment.cartReadyForProcessing', {cartName: displayName})}
        </Text>
        <TouchableOpacity
          style={styles.closeButton}
          testID="closeCartReadyBanner"
          onPress={handleClose}>
          <i className="icon-cancel" style={{fontSize: 22, color: '#1a1a1a'}} />
        </TouchableOpacity>
      </LinearGradient>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
    paddingHorizontal: 15,
    marginTop: 8,
    marginBottom: 16
  },
  gradient: {
    width: '100%',
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 15,
    paddingRight: 40,
    elevation: 5,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.25,
    shadowRadius: 3.84
  },
  message: {
    flex: 1,
    color: '#1a1a1a',
    fontFamily: fontFamily.font500,
    lineHeight: 22,
    textAlign: 'center'
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 10,
    height: 28,
    width: 28,
    justifyContent: 'center',
    alignItems: 'center'
  }
});

export default CartReadyBanner;
